import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  CHeader,
  CToggler,
  CHeaderBrand,
  CHeaderNav,
   
} from '@coreui/react' 

import { 
  TheHeaderDropdown, 
}  from './index'

const TheHeader = () => {
  const dispatch = useDispatch()
  const sidebarShow = useSelector(state => state.sidebarShow)
 


  useEffect(() =>{

   },[])
  const toggleSidebar = () => {

    
    const val = [true, 'responsive'].includes(sidebarShow) ? false : 'responsive'
    dispatch({ type: 'setRes', sidebarShow: val })
//     let valss = {
// type: 'setApi', vals: `[{"id":1,"_tag":"CSidebarNavDropdown","name":"Report","to":"/Report/ReportSegmentExp","icon":null,"_children":[{"id":1,"_tag":"CSidebarNavItem","name":"Reports","to":"/Report/ReportSegmentExp","icon":null,"fk_master":1}]},{"id":2,"_tag":"CSidebarNavDropdown","name":"Human Resources","to":"/hr/List","icon":null,"_children":[{"id":2,"_tag":"CSidebarNavItem","name":"New Employee","to":"/hr/New","icon":null,"fk_master":2},{"id":3,"_tag":"CSidebarNavItem","name":"Employee List","to":"/hr/List","icon":null,"fk_master":2},{"id":4,"_tag":"CSidebarNavItem","name":"Dependent","to":"/HR/Dependent","icon":null,"fk_master":2},{"id":5,"_tag":"CSidebarNavItem","name":"Salary Summary","to":"/Salary/Summary","icon":null,"fk_master":2},{"id":6,"_tag":"CSidebarNavItem","name":"Company","to":"/hr/List","icon":null,"fk_master":2},{"id":7,"_tag":"CSidebarNavItem","name":"Department","to":"/HR/department","icon":null,"fk_master":2},{"id":8,"_tag":"CSidebarNavItem","name":"Designations","to":"/HR/Designations","icon":null,"fk_master":2},{"id":9,"_tag":"CSidebarNavItem","name":"Transfer","to":"/hr/Transfer","icon":null,"fk_master":2},{"id":10,"_tag":"CSidebarNavItem","name":"Settlement","to":"/hr/Settle","icon":null,"fk_master":2},{"id":11,"_tag":"CSidebarNavItem","name":"Salary Summary","to":"/Salary/Summary","icon":null,"fk_master":2},{"id":12,"_tag":"CSidebarNavItem","name":"Re-Active Employee","to":"/HR/ReActive","icon":null,"fk_master":2},{"id":13,"_tag":"CSidebarNavItem","name":"Settings","to":"/hr/setting","icon":null,"fk_master":2}]},{"id":3,"_tag":"CSidebarNavDropdown","name":"Allowance","to":"/","icon":null,"_children":[{"id":14,"_tag":"CSidebarNavItem","name":"Add ","to":"/Salary/EmployeeAllownce","icon":null,"fk_master":3},{"id":15,"_tag":"CSidebarNavItem","name":"Education","to":"/HR/Education","icon":null,"fk_master":3},{"id":16,"_tag":"CSidebarNavItem","name":"Transportation","to":"/HR/Transport","icon":null,"fk_master":3}]},{"id":4,"_tag":"CSidebarNavDropdown","name":"Deduction","to":"/","icon":null,"_children":[{"id":17,"_tag":"CSidebarNavItem","name":"Add","to":"/hr/Deduction","icon":null,"fk_master":4},{"id":18,"_tag":"CSidebarNavItem","name":"Income Tax","to":"/hr/IncomeTax","icon":null,"fk_master":4},{"id":19,"_tag":"CSidebarNavItem","name":"Loan","to":"/hr/Loan","icon":null,"fk_master":4}]},{"id":5,"_tag":"CSidebarNavDropdown","name":"Attendence","to":"/","icon":null,"_children":[{"id":20,"_tag":"CSidebarNavItem","name":"Summary","to":"/hr/AttList","icon":null,"fk_master":5},{"id":21,"_tag":"CSidebarNavItem","name":"Absent Management","to":"/hr/Absent","icon":null,"fk_master":5}]}]`

//     }
//     dispatch(valss)
//     console.log(valss)

//localStorage.setItem('ApiM',`[{"id":1,"_tag":"CSidebarNavDropdown","name":"Report","to":"/Report/ReportSegmentExp","icon":null,"_children":[{"id":1,"_tag":"CSidebarNavItem","name":"Reports","to":"/Report/ReportSegmentExp","icon":null,"fk_master":1}]},{"id":2,"_tag":"CSidebarNavDropdown","name":"Human Resources","to":"/hr/List","icon":null,"_children":[{"id":2,"_tag":"CSidebarNavItem","name":"New Employee","to":"/hr/New","icon":null,"fk_master":2},{"id":3,"_tag":"CSidebarNavItem","name":"Employee List","to":"/hr/List","icon":null,"fk_master":2},{"id":4,"_tag":"CSidebarNavItem","name":"Dependent","to":"/HR/Dependent","icon":null,"fk_master":2},{"id":5,"_tag":"CSidebarNavItem","name":"Salary Summary","to":"/Salary/Summary","icon":null,"fk_master":2},{"id":6,"_tag":"CSidebarNavItem","name":"Company","to":"/hr/List","icon":null,"fk_master":2},{"id":7,"_tag":"CSidebarNavItem","name":"Department","to":"/HR/department","icon":null,"fk_master":2},{"id":8,"_tag":"CSidebarNavItem","name":"Designations","to":"/HR/Designations","icon":null,"fk_master":2},{"id":9,"_tag":"CSidebarNavItem","name":"Transfer","to":"/hr/Transfer","icon":null,"fk_master":2},{"id":10,"_tag":"CSidebarNavItem","name":"Settlement","to":"/hr/Settle","icon":null,"fk_master":2},{"id":11,"_tag":"CSidebarNavItem","name":"Salary Summary","to":"/Salary/Summary","icon":null,"fk_master":2},{"id":12,"_tag":"CSidebarNavItem","name":"Re-Active Employee","to":"/HR/ReActive","icon":null,"fk_master":2},{"id":13,"_tag":"CSidebarNavItem","name":"Settings","to":"/hr/setting","icon":null,"fk_master":2}]},{"id":3,"_tag":"CSidebarNavDropdown","name":"Allowance","to":"/","icon":null,"_children":[{"id":14,"_tag":"CSidebarNavItem","name":"Add ","to":"/Salary/EmployeeAllownce","icon":null,"fk_master":3},{"id":15,"_tag":"CSidebarNavItem","name":"Education","to":"/HR/Education","icon":null,"fk_master":3},{"id":16,"_tag":"CSidebarNavItem","name":"Transportation","to":"/HR/Transport","icon":null,"fk_master":3}]},{"id":4,"_tag":"CSidebarNavDropdown","name":"Deduction","to":"/","icon":null,"_children":[{"id":17,"_tag":"CSidebarNavItem","name":"Add","to":"/hr/Deduction","icon":null,"fk_master":4},{"id":18,"_tag":"CSidebarNavItem","name":"Income Tax","to":"/hr/IncomeTax","icon":null,"fk_master":4},{"id":19,"_tag":"CSidebarNavItem","name":"Loan","to":"/hr/Loan","icon":null,"fk_master":4}]},{"id":5,"_tag":"CSidebarNavDropdown","name":"Attendence","to":"/","icon":null,"_children":[{"id":20,"_tag":"CSidebarNavItem","name":"Summary","to":"/hr/AttList","icon":null,"fk_master":5},{"id":21,"_tag":"CSidebarNavItem","name":"Absent Management","to":"/hr/Absent","icon":null,"fk_master":5}]}]`);
    console.log('Clickka')
 
  }


  const toggleSidebarMobile = () => {
    const val = [false, 'responsive'].includes(sidebarShow) ? true : 'responsive'
    dispatch({ type: 'setRes', sidebarShow: val })
    console.log('Clickka')
  }

  return (
    <CHeader withSubheader style={{
      backgroundColor:'#fffff'
}} > 
      <CToggler
        inHeader
        className="ml-md-3 d-lg-none"
        onClick={toggleSidebarMobile}
      />
      <CToggler
        inHeader
        className="ml-3 d-md-down-none"
        onClick={toggleSidebar}
      />
 
      <CHeaderBrand className="mx-auto d-lg-none" to="/">
      
      </CHeaderBrand>
 

      <CHeaderNav className="d-md-down-none mr-auto" style={{color:'black'}}>
      
        <div className="d-md-down-none mfe-2 c-subheader-nav">
        <h3>
       Welcome ! {localStorage.getItem('user_name')  +' , ' + localStorage.getItem('custAddress1')    }
       </h3>   </div>
       
      </CHeaderNav>

      <CHeaderNav className="px-3" >

        <TheHeaderDropdown/>
      </CHeaderNav>

   
    </CHeader>
  )
}

export default TheHeader
